/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import styles from './WaterConsumptionCard.module.css';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap';
import { FloBasicAreaChart } from 'components';
import { ChartPeriodControl } from './ChartPeriodControl';
import { ConsumptionPeriod, FormattedConsumptionData } from 'model';

type WaterConsumptionCardProps = {
  hasMultipleDevices: boolean,
  period: ConsumptionPeriod,
  onSelect: (period: ConsumptionPeriod) => void,
  consumptionData: FormattedConsumptionData,
}

export const WaterConsumptionCard: React.FC<WaterConsumptionCardProps> =  React.memo(({
  hasMultipleDevices,
  period,
  onSelect,
  consumptionData,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <Row>
        <Col xs="12">
          <Row>
            <Col xs="12" lg={hasMultipleDevices ? '6' : '8'}><span className={styles.title}>{t('Water Consumption')}</span></Col>
            <Col xs="12" lg={hasMultipleDevices ? '6' : '4'}>
              <ChartPeriodControl period={period} onSelect={onSelect} />
            </Col>
          </Row>
          <Row>
            <Col className={styles.chartWrapper} xs="12">
              <FloBasicAreaChart
                style       = {{ height: '240px' }}
                yAxisLabel  = {consumptionData.unitSystem}
                xAxisData   = {consumptionData.xAxis}
                series      = {[{
                  name: 'Water Consumption',
                  data: consumptionData.values
                }]}
                formatter   = {consumptionData.formatter}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
});